import { render, staticRenderFns } from "./PixRecurringDetailsModal.vue?vue&type=template&id=49c6136a&scoped=true"
import script from "./PixRecurringDetailsModal.vue?vue&type=script&lang=js"
export * from "./PixRecurringDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./PixRecurringDetailsModal.vue?vue&type=style&index=0&id=49c6136a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c6136a",
  null
  
)

export default component.exports